import React, {Component} from 'react';
import users from "../../consumers/users";
import OverView from "../components/dashboard/Overview";
import NotAllowed from '../components/dashboard/NotAllowed'
import {Loading} from "../../components/Loading";

class Admin extends Component {

    constructor(props) {
        super(props);
        this.state = {
            superAdmin: null
        };
    }

    componentDidMount() {
        const ref = this.props.reference;
        const uid = this.props.currentUser.uid;
        if (ref && uid) {
            ref.child(uid).on('value', this.handleChange.bind(this));
        }
    }

    handleChange(snapshot) {
        this.setState({superAdmin:snapshot.val()});
        this.props.currentUser.getIdToken(true);
    }

    componentWillUnmount() {
        const reference = this.props.reference;
        if (reference) {
            const uid = this.props.currentUser.uid;
            reference.child(uid).off('value');
        }
    }

    render() {
        const {superAdmin} = this.state;
        if (superAdmin === null) {
            return(<Loading visible={true}/>);
        }
        if (superAdmin) {
            return(<OverView/>);
        }
        return (
            <NotAllowed/>
        );
    }

}

export default users(Admin);


// WEBPACK FOOTER //
// ./src/admin/subscribers/Admin.js